import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as styles from './styles.css';
import formControl from './formControl';

class Select extends Component {
  static defaultProps = {
    isEditable: true,
    multi: false,
    testID: undefined,
    disabled: false,
  };

  static propTypes = {
    input: PropTypes.shape({
      onChange: PropTypes.func.isRequired,
      onBlur: PropTypes.func.isRequired,
      value: PropTypes.oneOfType(
        [
          PropTypes.string,
          PropTypes.number,
        ],
      ).isRequired,
    }).isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      })
    ).isRequired,
    multi: PropTypes.bool,
    isEditable: PropTypes.bool.isRequired,
    testID: PropTypes.string,
    disabled: PropTypes.bool,
  };

  value = () => (this.props.multi && this.props.input.value === '' ? [] : this.props.input.value);

  render() {
    const {
      input: { value, onChange, onBlur, ...otherInputProps },
      multi,
      disabled,
      isEditable,
      testID,
      options,
    } = this.props;

    if (isEditable === false) {
      const matchingOption = options.find(option => option.value === value);
      const label = matchingOption ? matchingOption.name : '-';
      return <div className={styles.value}>{label}</div>;
    }

    return (
      <select
        {...otherInputProps}
        multiple={multi}
        className="form-control"
        value={this.value()}
        disabled={disabled}
        onChange={onChange}
        onBlur={onBlur}
        data-testid={testID}
      >
        {options.map(option => (
          <option key={option.value} value={option.value}>{option.name}</option>
        ))}
      </select>
    );
  }
}

export default formControl(Select);
